import request from '../utils/axios'

/**
 * 用户登录
 * @param {Object} data - 登录信息
 * @param {string} data.username - 用户名
 * @param {string} data.password - 密码
 */
export const login = (data) => {
  return request({
    url: '/realPersonVerification/isAuditPass',
    method: 'post',
    data
  })
}

/**
 * 用户退出登录
 */
export const logout = () => {
  return request({
    loading:true,
    url: '/system/examManage/logout',
    method: 'post'
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = (pValue) => {
  return request({
    url: `/system/userInfo/getInfo/${pValue}`,
    method: 'get'
  })
}

// 获取阿里云图片资源前缀  configKey传 image_prefix
export const getAliyunImgPrefix = (configKey ='image_prefix') => {
  return request({
    url: `/system/config/configKey/${configKey}`,
    method: 'get'
  })
}
